import * as tslib_1 from "tslib";
import { MaterialGroupBase } from "@awayjs/stage";
import { RendererBase } from "./RendererBase";
/**
 * The DepthRenderer class renders 32-bit depth information encoded as RGBA
 *
 * @class away.render.DepthRenderer
 */
var DepthRenderer = (function (_super) {
    tslib_1.__extends(DepthRenderer, _super);
    /**
     * Creates a new DepthRenderer object.
     * @param renderBlended Indicates whether semi-transparent objects should be rendered.
     * @param distanceBased Indicates whether the written depth value is distance-based or projected depth-based
     */
    function DepthRenderer(stage) {
        if (stage === void 0) { stage = null; }
        var _this = _super.call(this, stage) || this;
        _this._materialGroup = new MaterialGroupBase(_this._pStage, DepthRenderer._abstractionClassPool);
        _this._iBackgroundR = 1;
        _this._iBackgroundG = 1;
        _this._iBackgroundB = 1;
        return _this;
    }
    /**
     *
     */
    DepthRenderer.prototype.enterNode = function (node) {
        var enter = node._iCollectionMark != RendererBase._iCollectionMark && node.isCastingShadow();
        if (!enter) {
            node._iCollectionMark = RendererBase._iCollectionMark;
            return false;
        }
        return _super.prototype.enterNode.call(this, node);
    };
    return DepthRenderer;
}(RendererBase));
export { DepthRenderer };
DepthRenderer._abstractionClassPool = Object();



// WEBPACK FOOTER //
// ../dist/lib/DepthRenderer.js